import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <>
        <style>{`
          @keyframes bouncy {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-20px); }
          }
        `}</style>
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white dark:bg-gray-950">
          <div className="flex items-end gap-2 h-10">
            <div className="w-4 h-4 rounded-full bg-[#3967fe] animate-[bouncy_0.5s_ease-in-out_infinite] [animation-delay:-0.3s]" />
            <div className="w-4 h-4 rounded-full bg-[#3967fe] animate-[bouncy_0.5s_ease-in-out_infinite] [animation-delay:-0.15s]" />
            <div className="w-4 h-4 rounded-full bg-[#3967fe] animate-[bouncy_0.5s_ease-in-out_infinite]" />
          </div>
        </div>
      </>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const needsOnboarding = user.user?.isOnboardingCompleted === false;

  if (needsOnboarding && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" state={{ from: location }} replace />;
  }

  if (!needsOnboarding && location.pathname === '/onboarding') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}